import { useRef, useEffect } from 'react';
import { TmapRouter } from './map';
import { useSendUserInput } from '../../../../provider/socketContext';
import { useHudStore, useLocationStore } from '../../../../store/sceneStore';

export const MapRouter = ({ ref }) => {
	const location = useLocationStore();
	const hud = useHudStore();

	const routerRef = useRef(null);
	const initializedRef = useRef(false);

	const sendUserInput = useSendUserInput();
	const pos = { lat: location.lat, lon: location.lon };

	useEffect(() => {
		if (ref.current && !initializedRef.current) {
			initializedRef.current = true;
			routerRef.current = new TmapRouter({
				licence: hud.license,
				sender: sendUserInput,
				naviRef: ref.current,
			});
			routerRef.current.init();
		}
	}, [hud.license, sendUserInput]);

	useEffect(() => {
		if (!!routerRef.current?.initialized_ && !!pos.lat && !!pos.lon) {
			routerRef.current.updatePosition(pos);
		}
	}, [pos, routerRef]);
	return <div className='h-[60vh] w-[40vw]' ref={ref} />;
};
